{
	"backLinkTitle": "Back to Plant list",
	"title": "MRV Cockpit: {{plantName}}",
	"plantId": "Plant ID: {{plantNumber}}"
}
